import React from 'react';
import PropTypes from 'prop-types';
import { MarkdownWrapper } from 'components/atoms';
import {
	FeaturedContentSection,
	PSPLinks,
	PSPHero,
	PSPReviewSection,
	StorageNearYou,
	ContentSection,
	FAQSection,
	CTABlock,
	CardStrip,
	SizeComparisonSection,
	PSPVideo,
} from '../../organisms';

export const PSPPageSectionsMap = {
	markdownSection: MarkdownWrapper,
	hero: PSPHero,
	reviews: PSPReviewSection,
	links: PSPLinks,
	featuredContent: FeaturedContentSection,
	faqs: FAQSection,
	inlineCTA: CTABlock,
	storageNearYou: StorageNearYou,
	content: ContentSection,
	cardStrip: CardStrip,
	sizeComparisonSection: SizeComparisonSection,
	video: PSPVideo,
};

function PSPModuleFactory({ type, props, children }) {
	if (type in PSPPageSectionsMap) {
		return React.createElement(
			PSPPageSectionsMap[type],
			{ ...props },
			children,
		);
	}
	return null;
}

PSPModuleFactory.propTypes = {
	children: PropTypes.node,
	props: PropTypes.object,
	type: PropTypes.string,
};

export default PSPModuleFactory;
